const validFromSelector = state => state.validityInterval.validFrom ? state.validityInterval.validFrom : state.urlParams.effectiveDate;
const validToSelector = state => state.validityInterval.validTo ? state.validityInterval.validTo : state.urlParams.validTo;

module.exports = {
    validFromSelector,
    validToSelector
};
